var rangePropType = {exports: {}};

export { rangePropType as __module };
